import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { NodeEditDialogComponent } from "app/components/dialog/node-edit-dialog/node-edit-dialog.component";
import { IncluirUriAlfrescoComponent } from "app/incluir-uri-alfresco/incluir-uri-alfresco.component";
import { ClienteModel } from "app/model/cliente/cliente.model";
import { ResponsePageable } from "app/model/cliente/pageable/responsePageable.model";
import { ClienteService } from "app/service/cliente/cliente.service";
import { PermissoesService } from "app/service/usuario/permissoes.service";

@Component({
  selector: "app-lista-clientes-pasta",
  templateUrl: "./lista-clientes-pasta.component.html",
  styleUrls: ["./lista-clientes-pasta.component.scss"],
})
export class ListaClientesPastaComponent implements OnInit {
  public page: ResponsePageable;
  cliente = {} as ClienteModel;
  clientes: ClienteModel[];
  authorityUser = [];
  public superUserGeneral = false;
  public clienteId: number = 2;

  private authorityArray: string[];
  public superUser = false;
  public listaRel = false;
  tipoEditor = false;
  folderEditor = false;
  tokenAss = false;
  autoriaEditor = false;
  itensPermissions = [
    "SUPER_USER",
    "EDIT_TIPO",
    "EDIT_FOLDER",
    "LIST_RELATORIO",
    "EDIT_TOKEN_ASSINADOR",
    "EDIT_DADOS_AUTORIA",
  ];

  constructor(
    public _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private clienteService: ClienteService,
    private permissoesService: PermissoesService,
    private router: Router
  ) {}

  ngOnInit() {
    this.listarClientesUsuario();
    this.getGlobalPermissionUser();
  }

  clearPerm() {
    this.tipoEditor = false;
    this.superUser = false;
    this.folderEditor = false;
    this.listaRel = false;
    this.tokenAss = false;
    this.autoriaEditor = false;
  }

  VerificarSePresente() {}

  getPermissionCliente(idCliente: number) {
    this.authorityArray = [];
    this.permissoesService.getPermissionEmpresa(idCliente).subscribe(
      (data: any[]) => {
        //verifica se nenhuma permissão foi encontrada
        this.authorityArray = data.map((el) => el.authority);
        if (
          !this.itensPermissions.some((e) => this.authorityArray.includes(e))
        ) {
          return this.openSnackBar("Não foram encontrados itens", true);
        }
        this.getAuthority();
      },
      (err) => {
        console.error(err);
        this.openSnackBar("Ocorreu um erro, tente novamente mais tarde", true);
      }
    );
  }

  getAuthority() {
    this.authorityArray.includes("SUPER_USER") ? (this.superUser = true) : null;
    this.authorityArray.includes("EDIT_TIPO") ? (this.tipoEditor = true) : null;
    this.authorityArray.includes("EDIT_FOLDER")
      ? (this.folderEditor = true)
      : null;
    this.authorityArray.includes("LIST_RELATORIO")
      ? (this.listaRel = true)
      : null;
    this.authorityArray.includes("EDIT_TOKEN_ASSINADOR")
      ? (this.tokenAss = true)
      : null;
    this.authorityArray.includes("EDIT_DADOS_AUTORIA")
      ? (this.autoriaEditor = true)
      : null;
  }

  getAuthorityUser() {
    if (this.authorityUser.includes("SUPER_USER")) {
      this.superUserGeneral = true;
    }
  }

  getGlobalPermissionUser() {
    this.permissoesService
      .getPermissionsInUserLogged()
      .subscribe((data: any[]) => {
        this.authorityUser = data.map((el) => el.name);
        this.getAuthorityUser();
      });
  }

  onClickAction(idCliente: number) {
    this.getPermissionCliente(idCliente);
  }

  listarClientesUsuario() {
    this.clienteService.getClientesAll().subscribe(
      (data) => {
        this.clientes = data;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  incluirUri() {
    let largura;
    if (innerWidth < 400) {
      largura = innerWidth - 50 + "px";
    } else {
      largura = innerWidth - innerWidth / 2 + "px";
    }
    const dialogRef = this.dialog.open(IncluirUriAlfrescoComponent, {
      data: { dataDialog: largura },
      width: largura,
    });
  }

  goToManterAspectos() {
    this.router.navigate(["/manter-aspecto", this.clienteId]);
  }

  openSnackBar(message: string, isErr: boolean) {
    this._snackBar.open(message, "", {
      horizontalPosition: "right",
      verticalPosition: "top",
      duration: 3000,
      panelClass: isErr ? ["info-snackbar"] : ["success-snackbar"],
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/lista-clientes-pasta/lista-clientes-pasta.component.ts